import request from '@/utils/request'

export function login(username, password, code) {
  let captchaVerification = code
  return request({
    url: 'auth/login?index=0',
    method: 'post',
    data: {
      username,
      password,
      captchaVerification
    }
  })
}

export function loginEn(username, password, code) {
  let captchaVerification = code
  return request({
    url: 'auth/login?index=0&english=1',
    method: 'post',
    data: {
      username,
      password,
      captchaVerification
    }
  })
}

export function loginLC(username, password) {
  return request({
    url: 'auth/login?index=0&hjy=1&english=',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: 'auth/info',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js